/**
 * Roles's keys
 */
export const StorageRoles = {
  roles: 'roles',
};
